import { render, staticRenderFns } from "./shipmentMaintenance.vue?vue&type=template&id=37fe11aa&scoped=true&"
import script from "./shipmentMaintenance.vue?vue&type=script&lang=js&"
export * from "./shipmentMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./shipmentMaintenance.vue?vue&type=style&index=0&id=37fe11aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe11aa",
  null
  
)

export default component.exports